// extracted by mini-css-extract-plugin
export default {"text-color-modal":"gocEJlfeBBWxaLs6N7kz","button-modal":"_X5ZpD9GgZpyJLakJPJ9","flex-container":"N68N9UTCVPoknXaWgx09"};